import { AppEvent } from "./AppEvents";

/**
 * An event fired whenever a notification is to be shown, used to close any currently shown
 * notification (we show only one at a time).
 */
export const NotificationStarting = new AppEvent<string>(
  "NOTIFICATION_STARTING"
);
